module.exports = __webpack_public_path__ + "media/images/baseCodelco-53ff91a07df7fa9c22e69bbd0e05f5ad.jpeg";